import { REQUIRED_DOCUMENTS } from "../../talentPipeline";

export function evaluateWorkerCompliance(workerProfile = {}) {
  const documents =
    workerProfile.documents ||
    workerProfile.credentialMap ||
    workerProfile.uploadedDocs ||
    {};

  const missingDocuments = REQUIRED_DOCUMENTS.filter((docItem) => {
    const item = documents[docItem.key];
    return !item || item.status !== "approved";
  }).map((docItem) => docItem.key);

  return {
    compliant: missingDocuments.length === 0,
    missingDocuments,
  };
}

export function formatDocumentLabel(docKey) {
  const labelMap = {
    id: "Government ID",
    government_id: "Government ID",
    license: "Professional License / Certification",
    professional_license: "Professional License / Certification",
    tb: "TB Test / Health Clearance",
    tb_test: "TB Test / Health Clearance",
    cpr: "CPR / BLS Certification",
    cpr_bls: "CPR / BLS Certification",
  };

  return labelMap[docKey] || docKey;
}